import { createClient } from "@supabase/supabase-js";

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

let supabase;

try {
  if (!supabaseUrl || !supabaseAnonKey) {
    console.error(
      "Faltan variables de entorno de Supabase. Verifique VITE_SUPABASE_URL y VITE_SUPABASE_ANON_KEY."
    );
    // Create a dummy client to prevent crash during import, but calls will fail
    supabase = {
      from: () => ({
        select: () =>
          Promise.resolve({
            data: null,
            error: { message: "Supabase no configurado" },
          }),
        insert: () =>
          Promise.resolve({
            data: null,
            error: { message: "Supabase no configurado" },
          }),
        update: () =>
          Promise.resolve({
            data: null,
            error: { message: "Supabase no configurado" },
          }),
        delete: () =>
          Promise.resolve({
            data: null,
            error: { message: "Supabase no configurado" },
          }),
        order: () => ({
          limit: () =>
            Promise.resolve({
              data: null,
              error: { message: "Supabase no configurado" },
            }),
        }),
      }),
      storage: {
        from: () => ({
          upload: () =>
            Promise.resolve({ error: { message: "Supabase no configurado" } }),
          getPublicUrl: () => ({ data: { publicUrl: "" } }),
        }),
      },
      auth: {
        onAuthStateChange: () => ({
          data: { subscription: { unsubscribe: () => {} } },
        }),
        getSession: () =>
          Promise.resolve({ data: { session: null }, error: null }),
        signInWithPassword: () =>
          Promise.resolve({ error: { message: "Supabase no configurado" } }),
        signOut: () => Promise.resolve({ error: null }),
      },
    };
  } else {
    supabase = createClient(supabaseUrl, supabaseAnonKey);
  }
} catch (error) {
  console.error("Error inicializando Supabase:", error);
  supabase = null;
}

export { supabase };
